import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Dashboard.css";

import { toast } from "react-toastify";

// Validation Schema
const schema = yup.object().shape({
  email: yup
  .string()
  .required("Email is required")
  .email("Invalid email format")
  .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format"),
  password: yup
  .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[a-z]/, "Must contain at least one lowercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .matches(/[@$!%*?&]/, "Must contain at least one special character (@$!%*?&)"),
});

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      const payload = {
        userName: data.email,
        password: data.password,
        deviceType: "web",
        deviceToken: "web",
      };
      const response = await login(payload);
      if (response.success) {
         toast.success(response.message)
        // navigate("/dashboard");
        navigate("/dashboard", { state: response.data });
      } else {
         toast.error(response.message);
      }
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <div className="landing-container mobile-css2">
      <div className="logo-container mobile-css">
        <img src="/images/mainLogo.png" alt="Logo" className="main-logo" />
      </div>
      <div className="form-container mobile-css3">
        <h2 className="form-title">Sign In</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Email */}
          <div className="input-group">
            <label className="input-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter it here"
              {...register("email")}
            />
            {errors.email && <small className="text-danger">{errors.email.message}</small>}
          </div>
          {/* Password */}
          <div className="input-group pass-ds1">
            <label className="input-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter it here"
              {...register("password")}
            />
            {errors.password && <small className="text-danger">{errors.password.message}</small>}
          </div>
          {/* Forgot Password */}
          <div className="forgot-password">
            <Link to="/forgot-password" className="text-decoration text-white">
              Forgotten your password?
            </Link>
          </div>
          {/* Login Button */}
          <button className="signin-btn" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Signing In..." : "SIGN IN"}
          </button>
        </form>
        {/* Signup Link */}
        <div className="mb-3 text-start">
          <Link to="/signup" className="text-decoration text-white">
            Not a member? Sign up here
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;

